__turbopack_context__.v({
  "perkDescription": "YourPerksCarousel-module__QL3Gza__perkDescription",
  "perkImage": "YourPerksCarousel-module__QL3Gza__perkImage",
  "perkSlide": "YourPerksCarousel-module__QL3Gza__perkSlide",
  "perkTitle": "YourPerksCarousel-module__QL3Gza__perkTitle",
  "perksCarousel": "YourPerksCarousel-module__QL3Gza__perksCarousel",
});
